/**
 * Test it's live customer card (P-2.12): the pretend customer, as the page holds it between
 * turns. Pure.
 *
 * The card IS the `contact` each message sends: nothing is kept on the server. After a reply the
 * page takes the server's card (`reply.trace.customer`, every simulated save applied through the
 * real writer's own rule) and marks what changed; the owner can edit any field at any time, and
 * the next message sends the card as it then stands.
 */

/**
 * The customer a channel starts with (P-2.12): on WhatsApp a sample name and phone, as every
 * WhatsApp customer arrives with both; on a website chat nothing at all.
 */
const SAMPLE = {
  name: 'نورة العجمي',
  phone: '+96599887744',
  email: 'noura@example.com',
};

export const blankCard = () => ({
  name: '',
  email: '',
  phone: '',
  attributes: [],
  labels: [],
});

export const startingCard = channel => {
  const card = blankCard();
  if (channel === 'whatsapp')
    return { ...card, name: SAMPLE.name, phone: SAMPLE.phone };
  if (channel === 'sms') return { ...card, phone: SAMPLE.phone };
  if (channel === 'email') return { ...card, email: SAMPLE.email };
  if (
    channel === 'instagram' ||
    channel === 'messenger' ||
    channel === 'telegram'
  ) {
    return { ...card, name: SAMPLE.name };
  }
  return card;
};

/** The wire `contact`, or `undefined` when the card holds nothing. */
export const contactPayloadOf = card => {
  const payload = {};
  const name = (card?.name ?? '').trim();
  const email = (card?.email ?? '').trim();
  const phone = (card?.phone ?? '').trim();
  if (name) payload.name = name;
  if (email) payload.email = email;
  if (phone) payload.phone = phone;
  const attributes = {};
  (card?.attributes ?? []).forEach(row => {
    const key = (row?.key ?? '').trim();
    const value = (row?.value ?? '').trim();
    if (key && value) attributes[key] = value;
  });
  if (Object.keys(attributes).length > 0) payload.attributes = attributes;
  const labels = (card?.labels ?? [])
    .map(l => String(l).trim())
    .filter(Boolean);
  if (labels.length > 0) payload.labels = [...new Set(labels)];
  return Object.keys(payload).length > 0 ? payload : undefined;
};

/**
 * The card after a reply, and its marks: `changed` (fields a save just changed, "Just changed")
 * and `refused` (saves the real system would refuse, shown struck through with the reason).
 * With no server card (an older BFF, a failed turn) the card stays as it was, unmarked.
 */
export const cardAfterReply = (card, customer) => {
  if (!customer) return { card, changed: [], refused: [] };
  const next = {
    name: customer.name ?? '',
    email: customer.email ?? '',
    phone: customer.phone ?? '',
    attributes: Object.entries(customer.attributes ?? {}).map(
      ([key, value]) => ({
        key,
        value,
      })
    ),
    labels: [...(customer.labels ?? [])],
  };
  const changes = customer.changes ?? [];
  return {
    card: next,
    changed: changes.filter(c => c.saved).map(c => c.field),
    refused: changes
      .filter(c => !c.saved)
      .map(c => ({ field: c.field, value: c.after, reason: c.reason })),
  };
};
